// --- Routing ---

export function createPageUrl(pageName: string): string {
  const kebabCase = pageName
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .toLowerCase();
  
  return `/${kebabCase}`;
}
